(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["joy-ai-preview"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('joy-ai-preview')) {
  customElements.define('joy-ai-preview', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      this.history = this.history || [];
      this.input = this.querySelector('textarea');
      this.form = this.querySelector('form');
      this.sendButton = this.querySelector('[data-joy-ai-send]');
      this.status = this.querySelector('[data-joy-ai-status]');
      this.transcript = this.querySelector('[data-joy-ai-messages]');
      this.seed = this.querySelector('[data-joy-ai-seed]');
      this.contact = this.querySelector('[data-joy-ai-contact]');
      this.prompts = [...this.querySelectorAll('[data-joy-ai-prompt]')];
      this.locale = (this.dataset.locale || 'ro').toLowerCase().split('-')[0];
      if (!['ro', 'en', 'hu'].includes(this.locale)) this.locale = 'ro';
      this.endpoint = this.getEndpoint();
      this.querySelector('[data-joy-ai-unavailable]').hidden = Boolean(this.endpoint);
      this.setBusy(false);
      const options = { signal: this.events.signal };
      this.form.addEventListener('submit', event => {
        event.preventDefault();
        this.submitMessage();
      }, options);
      this.input.addEventListener('keydown', event => {
        if (event.key === 'Enter' && !event.shiftKey && !event.isComposing && event.keyCode !== 229) {
          event.preventDefault();
          this.submitMessage();
        }
      }, options);
      this.prompts.forEach(button => {
        button.addEventListener('click', () => {
          if (this.busy || !this.endpoint) return;
          this.input.value = button.dataset.joyAiPrompt;
          this.status.textContent = '';
          this.input.focus({ preventScroll: true });
        }, options);
      });
      this.querySelector('.joy-ai__start').addEventListener('click', event => {
        event.preventDefault();
        const target = this.endpoint ? this.input : this.contact;
        target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
        target.focus({ preventScroll: true });
      }, options);
    }
    disconnectedCallback() {
      this.events?.abort();
      this.events = null;
      this.request?.abort();
      this.request = null;
      clearTimeout(this.timeout);
      this.pendingTurn?.remove();
      this.pendingTurn = null;
      this.status.textContent = '';
    }
    getEndpoint() {
      try {
        const url = new URL(this.dataset.endpoint || '');
        if (url.protocol !== 'https:' || url.username || url.password || url.hash) return null;
        return url.href;
      } catch {
        return null;
      }
    }
    setBusy(busy) {
      this.busy = busy;
      const disabled = busy || !this.endpoint;
      this.input.disabled = disabled;
      this.sendButton.disabled = disabled;
      this.prompts.forEach(button => { button.disabled = disabled; });
      this.form.setAttribute('aria-busy', String(busy));
      this.status.dataset.busy = String(busy);
    }
    textElement(tag, className, text) {
      const element = document.createElement(tag);
      if (className) element.className = className;
      element.textContent = text;
      return element;
    }
    safeStoreURL(value, productsOnly = false) {
      if (typeof value !== 'string' || value.length > 2000) return null;
      try {
        const url = new URL(value, 'https://joysilver.ro');
        if (url.protocol !== 'https:' || !['joysilver.ro', 'www.joysilver.ro'].includes(url.hostname) || url.port || url.username || url.password) return null;
        const path = productsOnly ? /^\/(?:[a-z]{2}\/)?products\/[^/]+\/?$/ : /^\/(?:[a-z]{2}\/)?(?:products|collections|pages|policies)\/[^/]+\/?$/;
        if (!path.test(url.pathname)) return null;
        if (!productsOnly && !['/pages/contact', '/pages/livrare-plata-retur', '/pages/magazine', '/pages/despre-noi'].includes(url.pathname.replace(/\/$/, ''))) return null;
        url.hostname = 'joysilver.ro';
        const variant = productsOnly ? url.searchParams.get('variant') : null;
        url.search = '';
        if (variant && /^\d+$/.test(variant)) url.searchParams.set('variant', variant);
        url.hash = '';
        return url.href;
      } catch {
        return null;
      }
    }
    safeImageURL(value) {
      if (typeof value !== 'string' || value.length > 2000) return null;
      try {
        const url = new URL(value, 'https://joysilver.ro');
        if (url.protocol !== 'https:' || url.port || url.username || url.password) return null;
        if (url.hostname === 'cdn.shopify.com' && url.pathname.startsWith('/s/files/')) return url.href;
        if (['joysilver.ro', 'www.joysilver.ro'].includes(url.hostname) && url.pathname.startsWith('/cdn/shop/')) return url.href;
        return null;
      } catch {
        return null;
      }
    }
    iconElement(name) {
      const namespace = 'http://www.w3.org/2000/svg';
      const svg = document.createElementNS(namespace, 'svg');
      const attributes = { class: 'joy-icon joy-icon--' + name, viewBox: '0 0 24 24', width: '1em', height: '1em', fill: 'none', stroke: 'currentColor', 'stroke-width': '1.5', 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'aria-hidden': 'true', focusable: 'false', style: 'display:inline-block;vertical-align:-.125em;flex-shrink:0' };
      Object.entries(attributes).forEach(([key, value]) => svg.setAttribute(key, value));
      const path = document.createElementNS(namespace, 'path');
      path.setAttribute('d', name === 'bloom' ? 'M12 2v20M2 12h20M4.93 4.93l14.14 14.14M4.93 19.07L19.07 4.93' : 'M5 19 19 5M5 5h14v14');
      svg.append(path);
      return svg;
    }
    addTurn(role, text) {
      const turn = document.createElement('div');
      turn.className = 'joy-ai__turn';
      turn.setAttribute('role', 'group');
      turn.setAttribute('aria-label', role === 'user' ? this.dataset.you : this.dataset.name);
      const bubble = document.createElement('div');
      bubble.className = role === 'user' ? 'joy-ai__customer' : 'joy-ai__reply';
      const label = this.textElement('span', role === 'user' ? '' : 'joy-ai__small-flower', role === 'user' ? this.dataset.you : '');
      if (role !== 'user') {
        label.setAttribute('aria-hidden', 'true');
        label.append(this.iconElement('bloom'));
      }
      bubble.append(label, this.textElement('p', '', text));
      turn.append(bubble);
      this.transcript.append(turn);
      return turn;
    }
    addProducts(turn, products) {
      if (!Array.isArray(products)) return;
      const grid = document.createElement('div');
      grid.className = 'joy-ai__products';
      products.slice(0, 4).forEach(product => {
        if (!product || typeof product.title !== 'string' || !product.title.trim() || !Number.isSafeInteger(product.price) || product.price < 0 || product.currency !== 'RON') return;
        const url = this.safeStoreURL(product.url, true);
        const imageURL = this.safeImageURL(product.image);
        if (!url) return;
        const link = document.createElement('a');
        link.className = 'joy-ai__product';
        link.href = url;
        const frame = document.createElement('div');
        frame.className = 'joy-ai__product-image';
        const image = document.createElement('img');
        if (imageURL) image.src = imageURL;
        image.alt = product.title.slice(0, 300);
        image.loading = 'lazy';
        image.width = 240;
        image.height = 240;
        image.referrerPolicy = 'no-referrer';
        frame.append(image);
        const copy = document.createElement('div');
        copy.className = 'joy-ai__product-copy';
        copy.append(this.textElement('span', '', product.title.slice(0, 300)));
        const price = document.createElement('div');
        const formattedPrice = new Intl.NumberFormat(this.locale, { style: 'currency', currency: 'RON' }).format(product.price / 100);
        const arrow = this.textElement('span', 'joy-ai__product-arrow', '');
        arrow.setAttribute('aria-hidden', 'true');
        arrow.append(this.iconElement('arrow-up-right'));
        price.append(this.textElement('strong', '', formattedPrice), arrow);
        copy.append(price);
        if (imageURL) link.append(frame);
        link.append(copy);
        grid.append(link);
      });
      if (grid.childElementCount) turn.append(grid);
    }
    addSources(turn, sources) {
      if (!Array.isArray(sources)) return;
      const links = document.createElement('div');
      links.className = 'joy-ai__sources';
      links.setAttribute('role', 'group');
      links.setAttribute('aria-label', this.dataset.sourcesLabel);
      const seen = new Set();
      sources.slice(0, 4).forEach(source => {
        const url = this.safeStoreURL(source?.url);
        if (!url || seen.has(url) || typeof source.title !== 'string') return;
        seen.add(url);
        const link = this.textElement('a', '', source.title.slice(0, 120));
        link.href = url;
        links.append(link);
      });
      if (links.childElementCount) turn.append(links);
    }
    addHandoff(turn) {
      const box = document.createElement('div');
      box.className = 'joy-ai__handoff';
      box.append(this.textElement('p', '', this.dataset.handoffLabel));
      const link = this.textElement('a', '', this.dataset.contactLabel);
      link.href = this.safeStoreURL(this.dataset.contactUrl) || 'https://joysilver.ro/pages/contact';
      box.append(link);
      turn.append(box);
    }
    async submitMessage() {
      if (this.busy || !this.endpoint) return;
      const message = this.input.value.trim();
      if (!message || message.length > 800) {
        this.status.textContent = message ? this.dataset.tooLong : this.dataset.empty;
        this.input.focus({ preventScroll: true });
        return;
      }
      let history = this.history.slice(-10);
      while (history.reduce((sum, entry) => sum + entry.content.length, 0) > 8000) history = history.slice(2);
      this.setBusy(true);
      this.status.textContent = this.dataset.loading;
      this.pendingTurn = this.addTurn('user', message);
      this.transcript.scrollTop = this.transcript.scrollHeight;
      const request = new AbortController();
      this.request = request;
      const timeout = setTimeout(() => request.abort(), 60000);
      this.timeout = timeout;
      try {
        const response = await fetch(this.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'omit',
          cache: 'no-store',
          redirect: 'error',
          referrerPolicy: 'no-referrer',
          signal: request.signal,
          body: JSON.stringify({ message, history, locale: this.locale })
        });
        if (!response.ok) {
          const error = new Error('request_failed');
          error.status = response.status;
          throw error;
        }
        const result = await response.json();
        if (!result || typeof result.reply !== 'string' || !result.reply.trim() || result.reply.length > 2000) throw new Error('invalid_reply');
        if (!this.isConnected || this.request !== request) return;
        const reply = result.reply.trim();
        const turn = this.addTurn('assistant', reply);
        this.addProducts(turn, result.products);
        this.addSources(turn, result.sources);
        if (result.handoff === true) this.addHandoff(turn);
        this.history = [...this.history, { role: 'user', content: message }, { role: 'assistant', content: reply }].slice(-10);
        while (this.transcript.childElementCount > 10) this.transcript.firstElementChild.remove();
        this.seed.hidden = true;
        this.pendingTurn = null;
        this.input.value = '';
        this.status.textContent = '';
        this.transcript.scrollTop = this.transcript.scrollHeight;
      } catch (error) {
        if (!this.isConnected || this.request !== request) return;
        this.pendingTurn?.remove();
        this.pendingTurn = null;
        this.status.textContent = error.status === 429 ? this.dataset.rateLimit : this.dataset.error;
      } finally {
        clearTimeout(timeout);
        if (this.isConnected && this.request === request) {
          this.request = null;
          this.setBusy(false);
          this.input.focus({ preventScroll: true });
        }
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["joy-brand"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('joy-store-locator')){
  customElements.define('joy-store-locator',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;
      this.ready=true;this.controller=new AbortController();this.options={signal:this.controller.signal};
      this.frame=this.querySelector('.joy-store-map');this.tiles=this.querySelector('.joy-map-tiles');this.markers=this.querySelector('.joy-map-markers');
      this.locations=[...this.querySelectorAll('[data-store-number]')].map(button=>({button,number:button.dataset.storeNumber,name:button.dataset.storeName,address:button.dataset.storeAddress,city:button.dataset.storeCity,lat:Number(button.dataset.storeLat),lng:Number(button.dataset.storeLng),route:button.closest('.joy-map-store').querySelector('.joy-map-route').href})).filter(s=>Number.isFinite(s.lat)&&Number.isFinite(s.lng));
      this.view='all';this.selected=null;this.zoom=8;this.started=false;this.tileCache=new Map();
      this.dataset.selectText=this.querySelector('[data-map-selected-name]').textContent;this.dataset.hintText=this.querySelector('[data-map-selected-address]').textContent;
      const start=()=>{if(this.started)return;this.started=true;this.fit(this.locations);};
      if('IntersectionObserver'in window){this.visibilityObserver=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){start();this.visibilityObserver.disconnect();}},{threshold:.01});this.visibilityObserver.observe(this.frame);}else start();
      this.resizeObserver=new ResizeObserver(()=>{if(this.started)this.fit(this.selected?[this.selected]:this.locations.filter(s=>this.view==='all'||s.city===this.view));});this.resizeObserver.observe(this.frame);
      this.addEventListener('click',e=>{
        const city=e.target.closest('[data-map-city]');if(city){this.view=city.dataset.mapCity;this.clearSelection();this.started=true;this.fit(this.locations.filter(s=>this.view==='all'||s.city===this.view));this.setCities();return;}
        const store=e.target.closest('[data-store-number]');if(store){this.select(this.locations.find(s=>s.button===store));return;}
        const zoom=e.target.closest('[data-map-zoom]');if(zoom){this.started=true;if(!this.center)this.fit(this.locations);this.zoom=Math.max(6,Math.min(17,this.zoom+Number(zoom.dataset.mapZoom)));this.render();}
      },this.options);
      this.frame.addEventListener('keydown',e=>{if(e.target!==this.frame)return;if(!this.center)start();const deltas={ArrowLeft:[-70,0],ArrowRight:[70,0],ArrowUp:[0,-70],ArrowDown:[0,70]};if(deltas[e.key]){e.preventDefault();const p=this.project(this.center,this.zoom),d=deltas[e.key];this.center=this.unproject({x:p.x+d[0],y:p.y+d[1]},this.zoom);this.render();}else if(e.key==='+'||e.key==='-'||e.key==='='){e.preventDefault();this.zoom=Math.max(6,Math.min(17,this.zoom+(e.key==='-'?-1:1)));this.render();}else if(e.key==='Home'){e.preventDefault();this.view='all';this.clearSelection();this.fit(this.locations);this.setCities();}},this.options);
      this.frame.addEventListener('pointerdown',e=>{if(e.pointerType!=='mouse'||e.button!==0||e.target.closest('button,a'))return;if(!this.center)start();this.drag={x:e.clientX,y:e.clientY,center:this.project(this.center,this.zoom)};this.frame.setPointerCapture(e.pointerId);this.frame.classList.add('is-dragging');},this.options);
      this.frame.addEventListener('pointermove',e=>{if(!this.drag)return;const dx=e.clientX-this.drag.x,dy=e.clientY-this.drag.y;this.tiles.style.transform=this.markers.style.transform='translate('+dx+'px,'+dy+'px)';},this.options);
      const endDrag=e=>{if(!this.drag)return;this.center=this.unproject({x:this.drag.center.x-(e.clientX-this.drag.x),y:this.drag.center.y-(e.clientY-this.drag.y)},this.zoom);this.drag=null;this.tiles.style.transform=this.markers.style.transform='';this.frame.classList.remove('is-dragging');this.render();};
      this.frame.addEventListener('pointerup',endDrag,this.options);this.frame.addEventListener('pointercancel',endDrag,this.options);
    }
    disconnectedCallback(){this.controller?.abort();this.resizeObserver?.disconnect();this.visibilityObserver?.disconnect();this.ready=false;}
    project(p,z){const scale=256*2**z,sin=Math.sin(Math.max(-85,Math.min(85,p.lat))*Math.PI/180);return{x:(p.lng+180)/360*scale,y:(.5-Math.log((1+sin)/(1-sin))/(4*Math.PI))*scale};}
    unproject(p,z){const scale=256*2**z;return{lng:p.x/scale*360-180,lat:Math.atan(Math.sinh(Math.PI*(1-2*p.y/scale)))*180/Math.PI};}
    fit(stores){
      if(!stores.length||!this.frame.clientWidth)return;
      this.zoom=stores.length===1?16:17;
      if(stores.length>1)for(let z=17;z>=6;z--){const p=stores.map(s=>this.project(s,z));if(Math.max(...p.map(i=>i.x))-Math.min(...p.map(i=>i.x))<this.frame.clientWidth-140&&Math.max(...p.map(i=>i.y))-Math.min(...p.map(i=>i.y))<this.frame.clientHeight-130){this.zoom=z;break;}}
      const p=stores.map(s=>this.project(s,this.zoom));this.center=this.unproject({x:(Math.max(...p.map(i=>i.x))+Math.min(...p.map(i=>i.x)))/2,y:(Math.max(...p.map(i=>i.y))+Math.min(...p.map(i=>i.y)))/2},this.zoom);this.render();
    }
    clearSelection(){this.selected=null;this.locations.forEach(s=>s.button.setAttribute('aria-pressed','false'));this.querySelector('[data-map-selected-name]').textContent=this.dataset.selectText;this.querySelector('[data-map-selected-address]').textContent=this.dataset.hintText;this.querySelector('[data-map-selected-route]').hidden=true;}
    setCities(){this.querySelectorAll('[data-map-city]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.mapCity===this.view)));}
    select(store){
      if(!store)return;this.started=true;this.selected=store;this.view=store.city;this.locations.forEach(s=>s.button.setAttribute('aria-pressed',String(s===store)));this.setCities();
      this.querySelector('[data-map-selected-name]').textContent=store.name;this.querySelector('[data-map-selected-address]').textContent=store.address;
      const link=this.querySelector('[data-map-selected-route]');link.href=store.route;link.hidden=false;this.fit([store]);
    }
    render(){
      if(!this.center)return;
      if(!this.dataset.selectText){this.dataset.selectText=this.querySelector('[data-map-selected-name]').textContent;this.dataset.hintText=this.querySelector('[data-map-selected-address]').textContent;}
      const w=this.frame.clientWidth,h=this.frame.clientHeight,c=this.project(this.center,this.zoom),left=c.x-w/2,top=c.y-h/2,count=2**this.zoom;
      const active=new Set();
      for(let x=Math.floor(left/256);x<=Math.floor((left+w)/256);x++)for(let y=Math.floor(top/256);y<=Math.floor((top+h)/256);y++){
        if(y<0||y>=count)continue;const wrapped=(x%count+count)%count,key=this.zoom+'/'+wrapped+'/'+y;active.add(key);let tile=this.tileCache.get(key);
        if(!tile){tile=new Image(256,256);tile.alt='';tile.draggable=false;tile.referrerPolicy='strict-origin-when-cross-origin';tile.addEventListener('load',()=>{this.querySelector('.joy-map-loading').hidden=true;},{once:true});tile.src=this.frame.dataset.tileUrl.replace('{z}',this.zoom).replace('{x}',wrapped).replace('{y}',y);this.tileCache.set(key,tile);}
        tile.style.left=(x*256-left)+'px';tile.style.top=(y*256-top)+'px';this.tiles.append(tile);
      }
      for(const tile of[...this.tiles.children]){const key=[...this.tileCache.entries()].find(([,v])=>v===tile)?.[0];if(!active.has(key))tile.remove();}
      if(this.tileCache.size>80)for(const[key,tile]of this.tileCache)if(!active.has(key)){this.tileCache.delete(key);if(this.tileCache.size<=60)break;}
      this.markers.replaceChildren();
      const groups=[];
      for(const store of this.locations){const p=this.project(store,this.zoom),point={store,x:p.x-left,y:p.y-top};if(point.x<-20||point.x>w+20||point.y<-20||point.y>h+20)continue;const group=groups.find(g=>Math.hypot(g.x-point.x,g.y-point.y)<45);if(group){group.points.push(point);group.x=group.points.reduce((s,p)=>s+p.x,0)/group.points.length;group.y=group.points.reduce((s,p)=>s+p.y,0)/group.points.length;}else groups.push({x:point.x,y:point.y,points:[point]});}
      for(const group of groups){const stores=group.points.map(p=>p.store),cluster=stores.length>1,store=stores[0];const button=document.createElement('button');button.type='button';button.className='joy-map-marker'+(cluster?' is-cluster':'')+(stores.includes(this.selected)?' is-selected':'');button.style.left=group.x+'px';button.style.top=group.y+'px';button.setAttribute('aria-label',cluster?this.frame.dataset.clusterLabel.replace('[count]',stores.length):store.name);
        const pin=document.createElement('span'),number=document.createElement('b');number.textContent=cluster?stores.length:store.number;pin.append(number);button.append(pin);
        if(this.zoom<11||cluster){const label=document.createElement('small');label.textContent=cluster&&stores.every(s=>s.city===store.city)?store.city:(this.zoom<11?store.city:store.name);button.append(label);}
        button.addEventListener('click',()=>{if(cluster){this.fit(stores);if(stores.every(s=>s.city===store.city)){this.view=store.city;this.setCities();}}else this.select(store);});this.markers.append(button);
      }
      this.frame.dataset.zoom=String(this.zoom);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
